import { useRef, useEffect } from 'react';
import { FormError, FormErrorsType } from '../../../types/errors';

export const useScrollToSectionOnError = <
  T extends HTMLElement = HTMLDivElement,
>(
  errors: FormError[],
  errorTypes: FormErrorsType | FormErrorsType[],
) => {
  const sectionRef = useRef<T>(null);
  const errorTypesArray = Array.isArray(errorTypes) ? errorTypes : [errorTypes];

  useEffect(() => {
    const hasRelevantError = errors.some((error) =>
      errorTypesArray.includes(error.errorType),
    );

    if (hasRelevantError && sectionRef.current?.scrollIntoView) {
      sectionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [errors]);

  return sectionRef;
};
